import { findIncluded } from 'jobs/my_listings/utils/jsonApiIncluded'

export function normalizePrivateNoteAttributes(attributes) {
  if (!attributes) {
    return null
  }

  return {
    content: attributes.content || '',
    createdAt: attributes.createdAt || attributes['created-at'] || null,
    updatedAt: attributes.updatedAt || attributes['updated-at'] || null,
    authorType: attributes.authorType || attributes.author_type || attributes['author-type'] || null
  }
}

export function hasPrivateNoteContent(noteAttributes) {
  return !!(noteAttributes && noteAttributes.content && noteAttributes.content.trim().length > 0)
}

export function extractPrivateNoteAttributes(eoi, included, embeddedNote) {
  if (embeddedNote && embeddedNote.attributes) {
    const normalized = normalizePrivateNoteAttributes(embeddedNote.attributes)

    return hasPrivateNoteContent(normalized) ? normalized : null
  }

  if (!eoi || !eoi.relationships) {
    return null
  }

  const relationship = eoi.relationships.privateNote || eoi.relationships['private-note']
  const ref = relationship && relationship.data

  if (!ref) {
    return null
  }

  const noteResource = findIncluded(included, ref)
  const normalized = normalizePrivateNoteAttributes(noteResource && noteResource.attributes)

  return hasPrivateNoteContent(normalized) ? normalized : null
}

export function buildPrivateNoteResource(noteId, attributes) {
  if (!hasPrivateNoteContent(attributes)) {
    return null
  }

  return {
    id: noteId != null ? String(noteId) : null,
    type: 'private-notes',
    attributes: {
      content: attributes.content,
      'created-at': attributes.createdAt || attributes['created-at'] || null,
      'updated-at': attributes.updatedAt || attributes['updated-at'] || null,
      'author-type': attributes.authorType || attributes.author_type || attributes['author-type'] || null
    }
  }
}

export function resolveJobIdFromEoi(eoi, fallbackJobId) {
  if (eoi && eoi.attributes) {
    const jobId = eoi.attributes.jobId || eoi.attributes.job_id

    if (jobId != null) {
      return jobId
    }
  }

  return fallbackJobId != null ? fallbackJobId : null
}
